/**
 * Utilities for working with Hermes mailboxes
 */

import GlobalClient from "./client";
import { ROUTES } from "../routes/paths";

/**
 * Get the current mailbox readerKey from the global Hermes client.
 * This is an async operation that waits for the mailbox to be created.
 *
 * @returns Promise that resolves to the readerKey, or undefined if not available
 */
export async function getCurrentMailboxReaderKey(): Promise<string | undefined> {
  try {
    const client = GlobalClient.get();
    const mailbox = await client.mailbox();
    return mailbox.readerKey;
  } catch (error) {
    console.error("[mailbox-utils] Error getting current mailbox:", error);
    return undefined;
  }
}

/**
 * Build a URL to the RPC viewer page with the current mailbox as a parameter.
 *
 * @returns Promise that resolves to the URL string
 */
export async function buildRpcViewerUrl(): Promise<string> {
  // The RPC viewer route is /app/devtools (with an optional :readerKey path
  // segment); the page also accepts ?readerKey= as a query param. Build it off
  // ROUTES so it always carries the /app prefix — a bare /devtools is not a
  // registered route and 404s ("not found") when opened.
  const readerKey = await getCurrentMailboxReaderKey();
  if (readerKey) {
    // readerKey as a path segment; useParams() decodes it on the page side.
    return ROUTES.APP.DEVTOOLS_WITH_KEY(encodeURIComponent(readerKey));
  }
  return ROUTES.APP.DEVTOOLS;
}
